<template>
  <div>
    <transition name="animate__animated animate__bounce" leave-active-class="animate__fadeOutTopRight"  enter-active-class="animate__fadeInTopRight">
      <div class="win" v-if="showCompare">
        <div class="flex win_title">
          <h4>
            <el-checkbox v-if="proList.length" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange"></el-checkbox>
            产品对比
          </h4>
          <i class="el-icon-close" @click="closeCompare(false)"></i>
        </div>
        <el-checkbox-group v-model="checkList" @change="onChangeCheckbox">
          <draggable v-model="proList" :options="dragOptions" @end="handleChange">
            <el-checkbox
              v-for="(item, index) in proList"
              :key="item.uuid"
              :label="item.uuid"
              class="flex probox"
            >
              <div class="flex-between">
                <p style="white-space: initial;width: 160px;color:#000">{{ item.name }}</p>
              <i class="el-icon-delete del" @click.stop.prevent="delComperaData(item, index)"></i>
              </div>
            </el-checkbox>
          </draggable>
        </el-checkbox-group>
        <p v-if="proList.length==0" class="more">暂无对比数据</p>
        <div class="probox btn" v-else>
          <el-button style="border:1px solid #169999;color:#169999;border-radius:8px" plain @click="getProductCompare"
            >开始对比</el-button
          >
        </div>
      </div>
    </transition>
    <!-- 收起的样式 -->
    <transition name="animate__animated animate__bounce" enter-active-class="animate__fadeInTopRight" leave-active-class="animate__fadeOutTopRight">
      <div class="win_min"  v-if="!showCompare" @click="closeCompare(true)">
        <el-badge :value="proList.length" class="item">
          <p>PK</p>
        </el-badge>
      </div>
    </transition>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
export default {
  components: { draggable },
  data() {
    return {
      proList: [],
      checkList: [], 
      lostCompare: null,
      isIndeterminate:false,
      checkAll:false,
      showCompare: true,
      dragOptions: {
        animation: 200,
        group: 'items'
      }
    };
  },
  watch: {
    "$store.state.compare"(val) {
       this.proList = val;
       this.changeStatus()
    },
    "$store.state.checkList"(val) {
       this.checkList = val;
       this.changeStatus()
    },
  },
  created() {
     // 创建监听器
    this.watchFn()
    this.handleCompareData();
  },
  
  methods: {
     handleChange(event) {
      // 处理拖拽完成后的位置调整
      const movedItem = this.proList[event.oldIndex];
      this.proList.splice(event.oldIndex, 1);
      this.proList.splice(event.newIndex, 0, movedItem);
      localStorage.setItem('lostCompare', JSON.stringify(this.proList));
      this.$store.commit("compareVuex", this.proList);
    },

    closeCompare(blo) {
      this.showCompare = blo
    },
    watchFn(){
      //初始化数据
      if(!localStorage.getItem('lostCompare')){
        localStorage.setItem('lostCompare',JSON.stringify([]))
      }
      this.proList = JSON.parse(localStorage.getItem('lostCompare'));
      setInterval(()=>{
        // console.log('jianting', this.lostCompare);
          // let lostCompare = JSON.parse(localStorage.getItem('lostCompare'));
          // this.lostCompare = lostCompare
          this.proList = JSON.parse(localStorage.getItem('lostCompare'));
          // this.proList = this.lostCompare
      },1000)
    },
    handleCheckAllChange(val){
      this.checkList = val?this.proList.map(m=>{ return m.uuid }):[]
      this.isIndeterminate = false;
       this.$store.commit('checkListVuex', this.checkList)
    },
    getProductCompare() {
      if(this.checkList.length < 2) {
        this.$message({
          message: '选择两条数据以上才可进行对比',
          type: 'warning'
        });
      }else {
        let routeData = this.$router.resolve({
          name: "productCompare",
        });
        window.open(routeData.href, "_blank");
      }
    },
    onChangeCheckbox(val) {
      this.$store.commit('checkListVuex', val)
      if(val.length){
        if(val.length == this.proList.length){
          this.isIndeterminate = false
          this.checkAll = true
        }else if(val.length < this.proList.length){
          this.checkAll = false
          this.isIndeterminate = true
        }
      }else{
        this.isIndeterminate = false
        this.checkAll = false
      }
    },
    // 获取vuex中的数据
    handleCompareData() {
      let lostComparebox = JSON.parse(localStorage.getItem('lostCompare'))
      // localStorage.setItem('vuex', JSON.stringify(lostComparebox));

      // this.proList = this.$store.state.compare;
      // this.checkList = this.$store.state.checkList;
      this.proList = lostComparebox;
      this.checkList = this.$store.state.checkList;
      this.changeStatus()
      // console.log("初始化---------", this.proList.length,this.checkList)
    },
    delComperaData(item, index) {
      // if(this.proList.length<=2){
      //   this.$message({
      //     message: '对比至少需要两条数据',
      //     type: 'warning'
      //   });
      // }else{
        this.proList.splice(index, 1);
        this.checkList = this.checkList.filter((items) => items != item.uuid);
        this.$store.commit('checkListVuex', this.checkList)
        this.$store.commit("compareVuex", this.proList);
        localStorage.setItem('lostCompare', JSON.stringify(this.proList));
      // }
    },
    changeStatus(){
      // console.log("变化",this.checkList,this.proList)
      if( this.checkList.length){
        if( this.checkList.length==this.proList.length){
          this.isIndeterminate = false
          this.checkAll = true
        }else if(this.checkList.length<this.proList.length){
          this.checkAll = false
          this.isIndeterminate = true
        }
      }else{
        this.isIndeterminate = false
        this.checkAll = false
      }
    }
  },
};
</script>

<style lang="less" scoped>
.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.win {
  width: 252px;
  background: #fff;
  z-index: 999;
  position: fixed;
  right: 4%;
  top: 50%;
  transform: translate(0, -50%);
  border-radius: 8px;

  .flex {
    display: flex;
    align-items: center;
  }
  .flex-between {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .win_title {
    background: #099;
    padding: 10px;
    color: #fff;
    border-radius: 8px 8px 0 0 !important;
    i {
      cursor: pointer;
    }
  }
  .probox {
    border: 1px solid #efefef;
    border-top: none;
    padding: 10px;
  }
  .del {
    cursor: pointer;
    margin-left: 20px;
    display: inline-block;
    color: #099;
  }
  /deep/.el-checkbox {
    margin-right: 0;
  }
  .btn {
    text-align: center;
    border-radius: 0 0 8px 8px !important;
  }
  .more {
    padding: 20px 0;
    text-align: center;
    color: #333;
    font-size: 14px;
  }
}
.win_min {
  background: #fff;
  cursor: pointer;
  -webkit-box-shadow: 0px 0px 17px -7px #009999;
  box-shadow: 0px 0px 17px -7px #009999;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  position: fixed;
  right: 23px;
  bottom: 58%;
  text-align: center;
  line-height: 53px;
  font-size: 15px;
  font-weight: 500;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  z-index: 99999;
  &:hover {
    background: #009999;
    color: #fff;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/product/components/compareWin.vue